import { useEffect, useState } from 'react';

/**
 * True once an analysis has been running for `timeoutMs` without finishing. It resets when
 * the analysis finishes, so a later re-analysis shows its loader again instead of the form.
 */
export const useAnalysisTimeout = (finished: boolean, timeoutMs: number) => {
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (finished) {
            setTimedOut(false);
            return undefined;
        }
        const timer = setTimeout(() => setTimedOut(true), timeoutMs);
        return () => clearTimeout(timer);
    }, [finished, timeoutMs]);

    return timedOut;
};
